import { render, staticRenderFns } from "./NewView.vue?vue&type=template&id=2d490710&scoped=true"
import script from "./NewView.vue?vue&type=script&lang=js"
export * from "./NewView.vue?vue&type=script&lang=js"
import style0 from "./NewView.vue?vue&type=style&index=0&id=2d490710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d490710",
  null
  
)

export default component.exports